import { useContext } from "react";
import StoreContext from "../context/StoreContext";

const STATE_CODES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
    'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
    'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
    'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
    'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
];


const useStore = () => {
    const {
        storeId,
        setStoreId,
        setSelectedStoreCallback,
        selectedStore,
        selectedStoreConfiguration,
        setUnfilteredStores,
        unfilteredStores,
        resetStoreState 
    } = useContext(StoreContext)

    return {
        storeId,
        setStoreId,
        setSelectedStoreCallback,
        selectedStore,
        selectedStoreConfiguration,
        setUnfilteredStores,
        unfilteredStores,
        STATE_CODES,
        resetStoreState 
    };
}

export default useStore;